import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';

export type SpinnerType = 'primary' | 'secondary' | 'icon';
export type SpinnerMode = 'fullscreen' | 'overlay' | 'inline';

@Component({
  selector: 'app-loading-spinner',
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    @if (mode() === 'fullscreen') {
      <div class="loading-container">
        <mat-spinner 
          [diameter]="diameter()" 
          [class]="spinnerType() + '-spinner'">
        </mat-spinner>
      </div>
    } @else if (mode() === 'overlay') {
      <div class="loading-overlay">
        <div class="loading-overlay__background"></div>
        <div class="loading-overlay__spinner">
          <mat-spinner 
            [diameter]="diameter()" 
            [class]="spinnerType() + '-spinner'">
          </mat-spinner>
        </div>
      </div>
    } @else {
      <mat-spinner 
        [diameter]="diameter()" 
        [class]="spinnerType() + '-spinner'">
      </mat-spinner>
    }
  `,
  styles: [`
    @use 'spacing/spacing-variables' as *;
    @use 'mixins/mixins' as *;

    .loading-container {
      @include flex-center;
      justify-content: center;
      flex-direction: column;
      gap: $spacing-lg;
      padding: 64px;
      height: calc(100vh - 300px);
      width: 100%;
    }

    .loading-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1000;
      pointer-events: all;
    }

    .loading-overlay__background {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.3);
      backdrop-filter: blur(1px);
    }

    .loading-overlay__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @include flex-center;
      flex-direction: column;
      gap: $spacing-lg;
    }
  `]
})
export class LoadingSpinnerComponent {
  spinnerType = input<SpinnerType>('primary');
  mode = input<SpinnerMode>('fullscreen');
  diameter = input<number>(48);
}
